import React from "react";
import { Box, Container, Skeleton, styled } from "@mui/material";
import { SectionTitle } from "../home-section-title/HomeSectionTitle";

const SkeletonWrapper = styled(Box)({
  display: "flex",
  gap: "32px",
  alignItems: "center",
  overflowX: "hidden",
});

const PartnersSkeleton = () => {
  return (
    <Box
      sx={{
        py: 6,
        backgroundColor: (theme) => theme.palette.grey[100],
      }}
    >
      <Container maxWidth="xl">
        <SectionTitle variant="h2" sx={{ mb: 4 }}>
          Our Trusted Partners
        </SectionTitle>

        <SkeletonWrapper>
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <Skeleton
              key={item}
              variant="rectangular"
              width={180}
              height={60}
              sx={{ borderRadius: 1 }}
            />
          ))}
        </SkeletonWrapper>
      </Container>
    </Box>
  );
};

export default PartnersSkeleton;
